import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  InjectionToken,
  Output,
  PLATFORM_ID,
  effect,
  inject,
  signal,
  ViewChild,
  ElementRef,
  AfterViewInit,
  computed,
  Signal,
  WritableSignal,
} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ComboRooms, RoomInfo } from '@core/models/domains/room';
import { AutoCompleteComponent } from '@shared/components/auto-complete/auto-complete.component';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { PdpSidebarReserveInfoComponent } from '../../components/pdp-sidebar-reserve-info/pdp-sidebar-reserve-info.component';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { MatButtonModule } from '@angular/material/button';
import { sample } from 'rxjs';
import { WebengageService } from '@core/services/webengage.service';
import { MomentService } from '@core/services/moment.service';
import { ExtraPersonCounterComponent } from '../../components/extra-person-counter/extra-person-counter.component';
import { PdpEcolodgeCalenderPriceComponent } from '../../ecolodge/sections/pdp-ecolodge-calender-price/pdp-ecolodge-calender-price.component';
import { PdpPriceDetailsComponent } from '../../components/pdp-price-details/pdp-price-details.component';
import { EcolodgeService } from '../../services/ecolodge.service';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { get } from 'http';
import { PdpStickyPriceDetail } from '@core/models/domains/general.model';

export const WINDOW = new InjectionToken<Window>('Window', {
  providedIn: 'root',
  factory: () => window,
});

@Component({
  selector: 'iho-pdp-sticky-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    RialToTomanPipe,
    SkeletonComponent,
    PdpSidebarReserveInfoComponent,
    RialToTomanPipe,
    AutoCompleteComponent,
    AutocompleteDirective,
    DatepickerComponent,
    DatepickerDirective,
    ExtraPersonCounterComponent,
    PdpEcolodgeCalenderPriceComponent,
    PdpPriceDetailsComponent,
    LoadingComponent,
  ],
  templateUrl: './pdp-sticky-sidebar.component.html',
  styleUrls: ['./pdp-sticky-sidebar.component.scss'],
  providers: [
    {
      provide: WINDOW,
      useFactory: (platformId: Object) => {
        return isPlatformBrowser(platformId) ? window : {};
      },
      deps: [PLATFORM_ID],
    },
  ],
})
export class PdpStickySidebarComponent implements AfterViewInit {
  pdpUiService = inject(HotelInfoUiService);
  selectedRooms: Array<RoomInfo & { count: number; id: number; name: string }> = [];
  lowestSelectedRoomsPrice = 0;
  lowestPriceInAllRooms = 0;
  allRoomsCount = 0;
  totalPrice = 0;
  nights = 0;
  startDate = '';
  endDate = '';
  hotelId = -1;
  hotelName = '';
  isShowAlertCount: boolean = false;
  isShowPriceDetails?: boolean = false;
  showLoading = false;
  activeFiltersNames: string[] = [];
  navigatorVal: any = isPlatformBrowser(this.platformId)
    ? /Android|iPhone/.test(this.window.navigator.userAgent)
    : undefined;
  @Output() goToRooms = new EventEmitter();
  @Output() searchNewEcolodgeCode = new EventEmitter();
  @Output() goToCalenderOutput = new EventEmitter();
  flagDisBtn = false;
  dialog = inject(MatDialog);
  priceDetails: WritableSignal<PdpStickyPriceDetail> = signal<PdpStickyPriceDetail>(
    {} as PdpStickyPriceDetail
  );
  autoCompleteService = inject(AutocompleteService);
  datePickerService = inject(DatepickerService);
  searchBoxService = inject(SearchBoxService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  EcolodgeService = inject(EcolodgeService);
  csrStatus = signal<any>(false);
  datepickerComponent = DatepickerComponent;
  @ViewChild('topSection') sectionBalayi!: ElementRef;
  ReserveInfoComponent: HTMLElement | null = null;
  FixedGuestCount: number = 1;
  ExtraGuestCount: number = 0;
  selectedComboRooms = computed(() => this.pdpUiService.selectedComboRooms());
  selectedComboPrice = 0;
  ihoExtraPersonPrice = 0;
  readonly computedPriceDetails = computed(() => this.priceDetails());

  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object,
    private webengageService: WebengageService,
    private momentService: MomentService
  ) {
    const { date, endDate } = this.route.snapshot.queryParams;
    if (date && endDate) {
      this.datePickerService.setStartDate(date);
      this.datePickerService.setEndDate(endDate);
    }


    effect(
      () => {
        if (this.datePickerService._state() && isPlatformBrowser(this.platformId)) {
          this.csrStatus.set(DatepickerComponent);
        }
      },
      { allowSignalWrites: true }
    );
    effect(
      () => {
        if (
          this.datePickerService._endDate() &&
          this.searchBoxService.accommodation() == 'ecolodge' &&
          !this.navigatorVal
        ) {
          let totalPerson = this.FixedGuestCount + this.ExtraGuestCount;
          this.getPriceDetails(totalPerson);
        }
      },
      { allowSignalWrites: true }
    );





    effect(() => {
      this.selectedRooms = this.pdpUiService.selectedRooms();
      this.flagDisBtn = false;
      this.activeFiltersNames = this.pdpUiService.activeRoomFiltersNames();
      this.nights = this.pdpUiService.nights;

      const [startDate, endDate] = this.pdpUiService.searchBoxService.getStartAndEndDate();
      this.startDate = startDate;
      this.endDate = endDate;
      this.hotelId = this.pdpUiService.hotelId;
      this.hotelName = this.pdpUiService.hotelFullName;
      if (this.selectedRooms?.length) {
        this.lowestSelectedRoomsPrice = this.calculateLowestPrice();
        this.calculateTotalPrice();
        this.ReserveInfoComponent = document.getElementById('sidebar-reserve-info');
        if (this.ReserveInfoComponent) this.setReserveInfoMaxHeight();
      } else {
        this.totalPrice = 0;
        this.lowestPriceInAllRooms = this.calculateLowestPrice();
      }
      //  this.autoCompleteService.setSelectedItem(this.selectedRooms);
    });

    effect(() => {
      if (this.selectedComboRooms()?.length && !this.selectedComboPrice) {
        this.selectedComboPrice = this.selectedComboRooms()[0]?.totalPrice?.ihoPrice;
        // this.calculateTotalPrice();
      }
    });
  }

  ngAfterViewInit(): void {
    // this.getPriceDetails(1);
  }
  isShowToast(ev: boolean) {
    this.isShowAlertCount = ev;
  }
  removeComboRooms() {
    this.pdpUiService.removeComboRoomsSelection();
  }

  setReserveInfoMaxHeight() {
    const maxHeight = Number(
      (
        this.window.innerHeight -
        Number(this.sectionBalayi.nativeElement.getBoundingClientRect().height.toFixed(0))
      ).toFixed(0)
    );
    this.ReserveInfoComponent!.style['maxHeight'] = String(maxHeight - 50) + 'px';
  }

  calculateLowestPrice(): number {
    if (this.selectedRooms?.length) {
      return Math.min(...this.selectedRooms!.map((room) => room.roomPrice.price.ihoPrice));
    } else {
      return this.findLowestPriceInAllRooms();
    }
  }

  findLowestPriceInAllRooms(): number {
    return this.pdpUiService.allRooms().reduce((min, roomInfo) => {
      const currentMin = Math.min(
        ...roomInfo.map((room) => (room.roomPrice ? room.roomPrice.price.ihoPrice : 0))
      );
      return Math.min(min, currentMin);
    }, Infinity);
  }

  calculateTotalPrice() {
    this.totalPrice = this.selectedRooms.reduce(
      (total, room) => total + room.roomPrice.price.ihoPrice * room.count,
      0
    );
  }

  removeSpecificRoom(roomId: number) {
    this.pdpUiService.resetCountSpecific.set(roomId);

    this.pdpUiService.selectedRooms.update((selectedRooms) =>
      selectedRooms.filter((room) => {
        return room.id != roomId;
      })
    );

    this.selectedRooms = this.pdpUiService.selectedRooms();
  }

  clearSelectedRooms() {
    this.selectedRooms = [];
    this.pdpUiService.selectedRooms.set([]);
    this.pdpUiService.resetCountAll.set(!this.pdpUiService.resetCountAll());
  }

  showDatePickerModal() {
    //   const dialogRef = this.dialog.open(, {
    //     panelClass: ['w-screen', 'w-fit', 'h-fit', '!max-w-full', '!backdrop-blur-sm'],
    //     data:{
    //     },
    //     autoFocus: false
    //   });
    //   // Handle the result or any other actions as needed
    //   dialogRef.afterClosed().subscribe(result => {
    //   });
  }

  search() {
    // this.bookAccommodation();
    let parameters = {
      id: this.autoCompleteService._selectedItem().id,
      type: this.autoCompleteService._selectedItem().type,
      link: this.autoCompleteService._selectedItem().link,
      name: this.autoCompleteService._selectedItem().name,
      state: this.autoCompleteService._selectedItem()?.state,
      startDate: this.datePickerService._startDate(),
      endDate: this.datePickerService._endDate(),
      isShabAdsCode: this.autoCompleteService._selectedItem().isShabAdsCode,
    };
    if (parameters.id != this.hotelId && isPlatformBrowser(this.platformId)) {
      if (this.searchBoxService.accommodation() == 'ecolodge') {
        this.searchNewEcolodgeCode.emit();
        this.datePickerService.ecolodgeCalenderDetails.set(false);
        this.pdpUiService.FixedGuestCount.set(0);

        // this.setNop({});
      }
      this.datePickerService.reservable.set(false);
      this.datePickerService.setState(false);
      this.datePickerService.setAllowToShow(false);
      this.trackHotelSearch(parameters);
      this.window.scrollTo({ top: 0, behavior: 'instant' });
      setTimeout(() => {
        this.searchBoxService.triggerSearch(parameters, false, this.autoCompleteService.adCode());
      }, 100);
    } else {
      if (
        isPlatformBrowser(this.platformId) &&
        (this.startDate != parameters.startDate || this.endDate != parameters.endDate)
      ) {
        if (this.searchBoxService.accommodation() != 'ecolodge') this.goToRooms.emit();
        setTimeout(() => {
          this.flagDisBtn = true;
          this.router
            .navigate([], {
              queryParams: {
                date: parameters.startDate,
                endDate: parameters.endDate,
                page: 1,
              },
              queryParamsHandling: 'merge',
              relativeTo: this.route,
              preserveFragment: true,
            })
            .finally(() => {
              this.flagDisBtn = false;
              if (this.searchBoxService.accommodation() != 'ecolodge') {
                this.pdpUiService.getRooms();
              }
            });
        }, 200);
      }
    }
  }

  goToCalender() {
    this.goToCalenderOutput.emit();
  }

  setNop(value: { nop: number; fixed: number } | any) {
    if (value.nop >= 0) this.isShowAlertCount = false;
    this.pdpUiService.FixedGuestCount.set(value.fixed);
    this.pdpUiService.ExtraGuestCount.set(value.nop - value.fixed < 0 ? 0 : value.nop - value.fixed);
    this.FixedGuestCount = value.fixed;
    this.ExtraGuestCount = value.nop - value.fixed < 0 ? 0 : value.nop - value.fixed;
    this.getPriceDetails(value.nop);
    this.datePickerService.setNop(value.nop);
  }
  getPriceDetails(value: number) {
    if (!this.datePickerService._allowToShow()) {
      if (this.pdpUiService.hotelInfo().Type === 1) {
        this.calcPriceDetailsForIhoPrividers();
        if (value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount) {
          const priceDetails = this.computedPriceDetails();
          const otherDetails = {
            title: `${value - this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount} نفر اضافه`,
            finalPrice:
              this.ihoExtraPersonPrice *
              (value - this.pdpUiService.hotelInfo().PersonCapacity?.FixedGuestCount),
          };
          this.priceDetails.set({
            ...priceDetails,
            finalPrice: priceDetails.finalPrice + otherDetails.finalPrice,
            otherDetails: [...priceDetails.otherDetails, otherDetails],
          });
        }
      } else {
        this.showLoading = true;
        if (!this.datePickerService._endDate()) return;
        let res: any = this.EcolodgeService.getProformaAccommodation(
          this.pdpUiService.hotelInfo().HouseId,
          this.datePickerService._startDate(),
          this.datePickerService._endDate(),
          value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount
            ? this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount?.toString()
            : value.toString(),
          value > this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount
            ? (value - this.pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount).toString()
            : '0',
          this.pdpUiService.hotelInfo()?.Type?.toString()
        );
        res.subscribe((res: any) => {
          this.showLoading = false;
          this.priceDetails.set(res);
          this.pdpUiService.ecolodgTotalPrice.set(res);
        });
      }
    }
  }

  calcPriceDetailsForIhoPrividers() {
    this.showLoading = true;
    const dates = Array.from(this.datePickerService.ecolodgeCalenderDetails() as Map<string, any>);
    
    const formmatedStartDate = this.datePickerService._startDate().replace(/\/(\d)\b/g, '/0$1');
    const formmatedEndDate = this.datePickerService._endDate().replace(/\/(\d)\b/g, '/0$1');
    this.ihoExtraPersonPrice = 0;
    let foundedRange = false
    const priceDetails: PdpStickyPriceDetail = {
      dayPriceDetails: [],
      finalPrice: 0,
      otherDetails: [],
    };


    for (const item of dates) {
      const date = item[0].replace(/\/(\d)\b/g, '/0$1');
      const data = item[1];

      if (date == formmatedStartDate) {
        foundedRange = true
      }

      if (foundedRange) {
        if (date >= formmatedEndDate) {
          break;
        } else {
          if (date >= formmatedStartDate) {
            this.ihoExtraPersonPrice += data.Price.ExtraIho;

            if (data.Price.Iho) {
              priceDetails.finalPrice += data.Price.Iho;
              const duplicateFoundedIndex = priceDetails.dayPriceDetails.findIndex(
                (x: any) => x.unitPrice == data.Price.Iho
              );

              if (duplicateFoundedIndex >= 0) {
                priceDetails.dayPriceDetails[duplicateFoundedIndex].count += 1;
                priceDetails.dayPriceDetails[duplicateFoundedIndex].finalPrice += data.Price.Iho;
              } else {
                priceDetails.dayPriceDetails.push({
                  count: 1,
                  finalPrice: data.Price.Iho,
                  unitPrice: data.Price.Iho,
                });
              }
            }
          }
        }
      }


    }

    this.priceDetails.set(priceDetails);
    this.showLoading = false;
  }

  trackHotelSearch(searchParams: Record<string, any>) {
    this.webengageService.track('Hotel Search', {
      hotelName: searchParams['name'],
      hotelType: searchParams['type'],
      numberOfNight: this.pdpUiService.nights,
      checkInDate: this.momentService.toGergorian(searchParams['startDate']),
      checkOutDate: this.momentService.toGergorian(searchParams['endDate']),
      hotelUrl: searchParams['link'],
    });
  }
}
